// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__vzh_C","savePackageButton":"ClientWallet_savePackageButton__3LneQ"};